import { useEffect } from "react";
import { useStart } from "features/start/fabric";


export default function useMatomo () {
	const start = useStart();

	useEffect(() => {
		const matomo = start.settings?.matomo;
		if (matomo) {
			var _mtm = window._mtm = window._mtm || [];
			_mtm.push({ "mtm.startTime": (new Date().getTime()), "event": "mtm.Start" });
			var d = document, g = d.createElement("script"), s = d.getElementsByTagName("script")[0];
			g.async = true; g.src = `${matomo.url}/js/container_${matomo.containerId}.js`; s.parentNode.insertBefore(g, s);
		}
	}, []);
}